// @flow
import type { UIState } from './ui.types.js';

export const SET_PROGRESS = 'SET_PROGRESS';
export const SET_MESSAGES = 'SET_MESSAGES';
export const REMOVE_MESSAGES = 'REMOVE_MESSAGES';
export const REMOVE_MESSAGES_BY_KEY = 'REMOVE_MESSAGES_BY_KEY';
export const SET_MODAL = 'SET_MODAL';

export const DEFAULT_GROUP = 'DEFAULT_GROUP';
export const defaultElement = 'all';

export const defaultUIState: UIState = {
  progress: false,
  messages: [],
  modals: {},
  elementsProgress: {}
};
